module.exports = __webpack_public_path__ + "static/media/H5_Mascopiro_met_bomen.4d46e9e2.png";